import React, { CSSProperties, useEffect, useRef, useState } from 'react';

// import constSCSS from '@src/styles/_const.scss';
import { bemCssModules } from '@utils';
// import { useDebounce } from '@utils/hooks';

import style from './Sidebar.scss';

const cn = bemCssModules(style, 'Sidebar');

// const { tablet } = constSCSS;
// const SCROLL_DEBOUNCE_TIME = 100;

// let anchorMarginTop = 0;
// let prevScrollY = window.scrollY;

const Sidebar: CustomFC = ({ className, children }) => {
  // const debounced = useDebounce(SCROLL_DEBOUNCE_TIME);

  const [anchorStyle, setAnchorStyle] = useState<CSSProperties>();
  const [contentStyle, setContentStyle] = useState<CSSProperties>();

  const anchorRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const sidebarRef = useRef<HTMLDivElement>(null);

  // const [contentBounds, setContentBounds] = useState<DOMRect>();

  // useEffect(() => {
  //   setContentBounds(contentRef.current?.getBoundingClientRect());
  // }, [contentRef.current]);

  // const handleOverflowContentScroll = () => {
  //   const { current: anchor } = anchorRef;
  //   const { current: sidebar } = sidebarRef;
  //   const { scrollY, innerHeight: viewportHeight } = window;

  //   if (anchor && contentBounds && sidebar) {
  //     const { top: contentTop, bottom: contentBottom } = contentBounds;
  //     const scrollDir = prevScrollY > scrollY ? 'up' : 'down';
  //     const hiddenContentPart = contentBottom - viewportHeight;
  //     const newContentStyle =
  //       scrollDir === 'down'
  //         ? { top: `${-hiddenContentPart + contentTop}px` }
  //         : { bottom: `${-hiddenContentPart}px` };

  //     setContentStyle(newContentStyle);

  //     if (scrollDir === 'down' && scrollY < anchorMarginTop) {
  //       anchorMarginTop = scrollY;
  //       setAnchorStyle({ marginTop: `${anchorMarginTop}px` });
  //     }
  //     if (scrollDir === 'up' && scrollY > anchorMarginTop + hiddenContentPart) {
  //       anchorMarginTop = scrollY - hiddenContentPart;
  //       setAnchorStyle({ marginTop: `${anchorMarginTop}px` });
  //     }

  //     prevScrollY = scrollY;
  //   }
  // };

  // const setScrollBehaviour = () => {
  //   if (contentBounds) {
  //     const { bottom, top } = contentBounds;

  //     if (bottom > window.innerHeight) {
  //       window.addEventListener('scroll', handleOverflowContentScroll);
  //     } else {
  //       window.removeEventListener('scroll', handleOverflowContentScroll);
  //       setAnchorStyle({ marginTop: '0px' });
  //       setContentStyle({ top: `${top}px` });
  //     }
  //   }
  // };

  // const handleResize = () => {
  //   const tabletSize = +tablet.slice(0, tablet.length - 2);

  //   if (window.innerWidth <= tabletSize) {
  //     window.removeEventListener('scroll', handleOverflowContentScroll);
  //   } else {
  //     setScrollBehaviour();
  //   }
  // };

  // useEffect(() => {
  //   setScrollBehaviour();
  //   window.addEventListener('resize', () => {
  //     debounced(handleResize);
  //   });

  //   return () => {
  //     window.removeEventListener('scroll', handleOverflowContentScroll);
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, [contentRef.current]);

  return (
    <div ref={sidebarRef} className={cn(null, [className])}>
      <div ref={anchorRef} className={cn('anchor')} style={anchorStyle} />
      <div ref={contentRef} className={cn('content-wrapper')} style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

export default Sidebar;
